export const capitalize = (str) => str[0].toUpperCase() + str.slice(1)
export const getPathFromLocation = (str) => str.split('/').slice(-1)[0]
